import { camelCase } from 'lodash';
import { parseString } from 'xml2js';

export const parseXml = (
  xml,
  callback,
) => {
  return parseString(
    xml,
    {
      attrNameProcessors: [camelCase],
      charsAsChildren: true,
      explicitArray: true,
      explicitChildren: true,
      explicitRoot: false,
      mergeAttrs: false,
      normalizeTags: true,
      preserveChildrenOrder: true,
      trim: true,
    },
    normalizeMiddleware(callback),
  );
};

const normalizeMiddleware = (
  callback,
) => {
  const normalizer = (element) => {
    const tagName = element['#name'];

    if (tagName === '__text__') {
      return {
        tagName: '',
        attributes: {},
        text: element._,
      };
    }

    const attributes = { ...element.$ };
    const renameProps = {
      class: 'className',
      for: 'htmlFor',
    };

    Object.keys(renameProps).forEach(key => {
      if (typeof attributes[key] !== 'undefined') {
        attributes[renameProps[key]] = attributes[key];
        delete attributes[key];
      }
    });

    return {
      attributes,
      tagName: element['#name'],
      children: (element.$$ || []).map(normalizer),
    };
  };

  return (error, result) => {
    callback(error, error ? result : normalizer(result));
  };
};
